import LazyFloatingAgent from '@/components/mobile/LazyFloatingAgent';
import OnboardingCoachmark from '../OnboardingCoachmark';
import { CreateShipmentOnboardingCoachmarkProps } from './types';
import { onboardingTargetIds } from '../../model/onboardingTargetIds';
import { Suspense } from 'react';

const CreateShipmentOnboardingCoachmark = (props: CreateShipmentOnboardingCoachmarkProps) => {
  const {
    isOpen,
    onBack,
    onClose,
    onNext,
    stepNumber,
    totalSteps
  } = props;

  return (
    <OnboardingCoachmark
      description="Сделайте расчёт и создайте поставку с помощью ИИ-агента."
      isOpen={isOpen}
      isTargetInteractive
      onBack={onBack}
      onClose={onClose}
      onPrimaryAction={onNext}
      offset={36}
      placement="top"
      stepNumber={stepNumber}
      targetHighlight={(
        <Suspense fallback={<span className="block h-[58px] w-[58px]" aria-hidden="true" />}>
          <LazyFloatingAgent
            placement="replica"
            shouldShowLoadingFallback={false}
            size="mini"
          />
        </Suspense>
      )}
      targetHighlightMode="replica"
      targetId={onboardingTargetIds.aiAgent}
      title="Создание поставки"
      totalSteps={totalSteps}
    />
  );
};

export default CreateShipmentOnboardingCoachmark;